import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AOS from "aos";
import "aos/dist/aos.css";
import React, { useEffect, useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import boost from "../../../assets/image/boost.jpg";
import api from "../../../assets/image/context.jpg";
import developer from "../../../assets/image/developer.jpg";
import "./Blog.scss";

const rightArrow = <FontAwesomeIcon style={{width:"10px"}} icon={faArrowRight} />;

const blogData = [
  {
    id: 1,
    picture: developer,
    title: "How react work under the wood.",
    text: "React is Javascript language. Created by Facebook. In job sector it has high demand.Today I will discus how react work under the wood. ",
    link: "https://nurul-alam.medium.com/all-you-need-to-know-about-react-d27bbfdd765e",
  },
  {
    id: 2,
    picture: boost,
    title: "Boost Your JavaScript",
    text: "Javascript is the most popular programming language in the world and that makes it a programmer’s great choice.",
    link: "https://nurul-alam.medium.com/",
  },
  {
    id: 3,
    picture: api,
    title: "Javascript interview question",
    text: "would you like Javascript or not It is the most uses languages.",
    link: "https://nurul-alam.medium.com/most-common-javascript-interview-question-d4048fe3b05a",
  },
];
const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  useEffect(() => {
    AOS.init({ duration: 3000 });
    setBlogs(blogData);
  }, []);
  return (
    <div id="blog">
      <div style={{overflow: "hidden" }}>
        <Container>
          <h1 style={{ color: "#100028",}} className="text-center mt-3 mt-md-0 mb-5 headline">
            MY BLOG
          </h1>
          <Row className="justify-content-center">
            {blogs.map((blog) => (
              <Col
                data-aos="flip-left"
                className="pb-4"
                key={blog.id}
                sm="12"
                md="4"
              >
                <Card className="h-100 blog-container shadow rounded-5">
                  <img
                    style={{ height: "150px", objectFit: "cover" }}
                    className="w-100"
                    src={blog.picture}
                    alt=""
                  />
                  <Card.Body>
                    <h5>{blog.title}</h5>
                    <p>{blog.text}</p>
                    <button>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={blog.link}
                      >
                        Read More
                      </a>
                      <span>{rightArrow}</span>
                    </button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default Blog;
